import { Link } from '@tanstack/react-router'
import type { LucideIcon } from 'lucide-react'

interface ErrorStateProps {
  icon: LucideIcon
  title: string
  subtitle: string
  ctaLabel: string
  ctaTo: string
}

export const ErrorState = ({
  icon: Icon,
  title,
  subtitle,
  ctaLabel,
  ctaTo,
}: ErrorStateProps) => (
  <div className="flex flex-col items-center justify-center text-center gap-4 py-24 px-6">
    <div className="w-20 h-20 rounded-full bg-orange/10 flex items-center justify-center">
      <Icon className="w-9 h-9 text-orange" strokeWidth={1.5} />
    </div>
    <h1 className="text-2xl font-bold text-black-900">{title}</h1>
    <p className="text-black-500 max-w-md">{subtitle}</p>
    <Link
      to={ctaTo}
      className="mt-2 rounded-lg px-5 py-1.5 transition text-lg font-bold flex items-center gap-2 bg-gradient-orange-fuschia text-white border border-transparent cursor-pointer hover:shadow-1 no-underline"
    >
      {ctaLabel}
    </Link>
  </div>
)
